import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMarriottComponent } from './simple-icons-marriott.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMarriottComponent ],
    exports:      [ SimpleIconsMarriottComponent ],
    bootstrap:    []
})
export class SimpleIconsMarriottModule {}
